/**
 * ============================================================
 * KARTING CENTRAL — BRANDS LANDING PAGE JS
 * File: assets/brands-landing.js
 * Dependencies: none (vanilla JS, no jQuery)
 * Load: defer in layout.liquid or via {% javascript %} in section
 * ============================================================
 */

(function () {
  'use strict';

  /* ── FAQ TOGGLE ──────────────────────────────────────────── */
  function initFaq() {
    const items = document.querySelectorAll('.kc-faq__item');
    if (!items.length) return;

    items.forEach(function (item) {
      const btn = item.querySelector('.kc-faq__q');
      if (!btn) return;

      btn.addEventListener('click', function () {
        const isOpen = item.classList.contains('is-open');

        // Close all others
        items.forEach(function (other) {
          other.classList.remove('is-open');
          const otherBtn = other.querySelector('.kc-faq__q');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        });

        // Toggle clicked
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── SMOOTH SCROLL FOR JUMP NAV ──────────────────────────── */
  function initJumpNav() {
    const links = document.querySelectorAll('.kc-brands-hero__jumpnav a');
    if (!links.length) return;

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        const href = link.getAttribute('href');
        if (!href || !href.startsWith('#')) return;

        const target = document.querySelector(href);
        if (!target) return;

        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });

        // Update URL without reload
        if (history.pushState) {
          history.pushState(null, null, href);
        }
      });
    });
  }

  /* ── ACTIVE JUMP NAV HIGHLIGHT ON SCROLL ─────────────────── */
  function initScrollSpy() {
    const sections = document.querySelectorAll('.kc-brand-section[id]');
    const links    = document.querySelectorAll('.kc-brands-hero__jumpnav a');
    if (!sections.length || !links.length) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          const id = entry.target.getAttribute('id');
          links.forEach(function (link) {
            link.classList.toggle(
              'is-active',
              link.getAttribute('href') === '#' + id
            );
          });
        });
      },
      { rootMargin: '-30% 0px -60% 0px' }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  /* ── INIT ─────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initFaq();
    initJumpNav();
    initScrollSpy();
  });

})();